namespace('compass.group');

compass.require('compass.hotel.HotelCardWidget');
compass.require('compass.group.BlockManageWidget');

compass.group.HotelManageWidget = compass.defineWidget(function HotelManageWidget(options) {
	var me = this;
	var $j = jQuery;
	var d = jQuery.dom;

	var _settings = options;
	var _hotelCardWidget;
	var _hotelHeaderWidget;

	me.blocks = [];
	me.update = function(updateData) {
		var ajaxSuccess = updateData.data.success;

		var updateMethods = {
			removeBlock: function(block, data) {
				_removeBlock(block, updateData.block_id);
			},
			assignedRooms: function(block, data) {
				if (ajaxSuccess) {
					block.widget.updateAndProcessAssignedRooms(data);
					_updateBlockRoomIds({
						newId: data.assignedRoomBase.reservationBase.blocked_room_id
					});
				} else {
					block.widget.processUnassignedRoomError();
				}
			},
			room: function(block, data) {
				_updateBlockRoomIds({
					newId: data.reservationBase.blocked_room_id,
					prevId: data.eventData.previous_blocked_room_id
				});
			},
			cancel: function(block, data) {
				if (ajaxSuccess) {
					_settings.hotelData.totalRooms -= 1;
					_hotelCardWidget.updateTotalRooms(_settings.hotelData.totalRooms);
					_hotelHeaderWidget.updateTotalRooms(_settings.hotelData.totalRooms);
				}
			},
		};

		_.each(me.blocks, function(block) {
			if(updateData.block_id === block.block_id) {
				_.each(updateData.data, function(data, key) {
					if(updateMethods[key]) {
						//Send to keen to collect more info, in case where data is undefined
						if(data) {
							data.eventData = updateData.eventData; // attaching frontend state event data
						} else {
							jQuery.ajax({
								url : '/sendToKeen',
								type: 'POST',
								ignoreTimeout : true,
								data: JSON.stringify({ 'stream': 'compass_hotelManageWidget', eventData: updateData.eventData }),
								dataType: 'json',
								error: function(event) {} //If call fails, suppress
							});
						}
						updateMethods[key](block, data);
					}
				});
				block.widget.update(updateData);
			}
		});
	};

	_settings.hotelData.totalRooms = _.reduce(
		_.map(_settings.blockData, function(block) {
			return block.numTotalRooms;	
		}), function(roomsSum, rooms) {
			return roomsSum + rooms;
	});

	// only if every block is uneditable, then the hotel should be uneditable
	_settings.hotelData.editable = !_.every(_settings.blockData, function(block) {
		return !block.editable;
	});

	// Create a list of assocaited blocked_room_ids for every assigned room
	_settings.hotelData.assigned_blocked_room_ids_list = _.map(_settings.blockData[0].assignedRooms,
		function(assignedRooms) {
			return _.find(_settings.blockData[0].allRoomTypes, 
				function(allRoomTypes) { 
					if (allRoomTypes.roomTypeBase.room_id === assignedRooms.roomTypeBase.room_id) return true;
				}).blocked_room_id.toString();
		});

	// Updates hotel level blocked room ids when rooms update
	var _updateBlockRoomIds = function(blockedRoom) {
		var ids = _settings.hotelData.assigned_blocked_room_ids_list;
		var newId = blockedRoom.newId.toString();
		var prevId = _.has(blockedRoom, 'prevId') ? blockedRoom.prevId.toString() : null;

		ids.push(newId);

		var i = _.indexOf(ids, prevId);
		if(i != -1){
			ids.splice(i, 1);
		}

		ids = _.uniq(ids);
		ids = ids.sort();

		_settings.hotelData.blocked_room_ids = ids;
	};

	var _removeBlock = function(block, block_id) {
		block.widget.remove();
		me.blocks = _.reject(me.blocks, function(block) {
			return block_id === block.block_id;
		});

		if(me.blocks.length === 0) {
			me.trigger('HotelManageWidget.removeHotel', {
				hotel_id: _settings.hotelData.hotelBase.hotel_id
			});
		}
	};

	var _drawHotelCard = function() {
		var hotelCardContainer = d.div({ className: 'hotelCardContainer'});
		var hotelCardAndPolicyLinkContainer = d.div({ className: 'hotelCardAndPolicyLinkContainer'});

		var hotelCardData = _settings.hotelData.hotelBase;
		hotelCardData["avgRate"] = _settings.hotelData.avgRate;
		hotelCardData["hqHotel"] = _settings.hotelData.hotelBase.hqHotel;
		hotelCardData["hotelId"] = _settings.hotelData.hotelBase.hotel_id;
		hotelCardData["totalRooms"] = _settings.hotelData.totalRooms;
		hotelCardData["images"]["main"] = _settings.hotelData.image;
	
		_hotelCardWidget = new compass.hotel.HotelCardWidget(hotelCardAndPolicyLinkContainer, {
			WUID: 'groupManage_hotelCardWidget',
			hotel: hotelCardData,
			meetingInfo: _settings.meetingInfo,
			displayHotelStars: _settings.meetingInfo.displayHotelStars,
			showAvailability: false,
			showAverageRate: false,
			hideDistance: _settings.hideDistance
		});

		var policiesLink = d.a("View Hotel Policies").activate(function() {
			var blocked_room_ids = _settings.hotelData.blocked_room_ids;
			me.trigger('HotelManageWidget.showPolicies', {
				blockRoomIds: blocked_room_ids
			});
		});
		hotelCardAndPolicyLinkContainer.append(policiesLink);

		hotelCardContainer.append(hotelCardAndPolicyLinkContainer);

		return hotelCardContainer;
	};

	var _drawHotelHeader = function() {
		var hotelHeaderContainer = d.div({ className: 'hotelHeaderContainer'});
		var hotelHeaderAndPolicyLinkContainer = d.div({ className: 'hotelHeaderAndPolicyLinkContainer'});

		var hotelHeaderData = _settings.hotelData.hotelBase;
		hotelHeaderData["avgRate"] = _settings.hotelData.avgRate;
		hotelHeaderData["hqHotel"] = _settings.hotelData.hotelBase.hqHotel;
		hotelHeaderData["hotelId"] = _settings.hotelData.hotelBase.hotel_id;
		hotelHeaderData["totalRooms"] = _settings.hotelData.totalRooms;
		hotelHeaderData["images"] = [_settings.hotelData.image];

		_hotelHeaderWidget = new compass.hotel.HotelHeaderWidget(hotelHeaderAndPolicyLinkContainer, {
			WUID: 'groupManage_hotelHeaderWidget',
			hotel: hotelHeaderData
		});

		var policiesLink = d.a("View Hotel Policies").activate(function() {
			var blocked_room_ids = _settings.hotelData.blocked_room_ids;
			me.trigger('HotelManageWidget.showPolicies', {
				blockRoomIds: blocked_room_ids
			});
		});
		hotelHeaderAndPolicyLinkContainer.append(policiesLink);

		hotelHeaderContainer.append(hotelHeaderAndPolicyLinkContainer);

		return hotelHeaderContainer;
	};

	me.render = function(widgetElem) {
		var blockWidgetContainer = d.div({ className: 'blockWidgetContainer'});

		if(!_settings.hotelData.editable) {
			blockWidgetContainer.append(d.div({ className: 'hotelCutoffMessage' },
				_settings.labels.hotelCutoffMessage
			));
		}
		_.each(_settings.blockData, function(block) {
			var _blockManageWidget = new compass.group.BlockManageWidget(blockWidgetContainer, {
				WUID: block.hotelName + ' ' + block.blockName,
				hotelData: _settings.hotelData,
				blockData: block,
				meetingInfo: _settings.meetingInfo,
				requestsInfo: _settings.requestsInfo,
				cancelInfo: _settings.cancelInfo,
				groupInfo: _settings.groupInfo,
				countriesAndStates: _settings.countriesAndStates,
				cancelReasons : _settings.cancelReasons,
				searchMode :_settings.searchMode,
				canSendConfo: _settings.canSendConfo
			});
			me.blocks.push({block_id: block.blockBase.block_id, widget: _blockManageWidget});
		});

		widgetElem.append(_drawHotelHeader());
		widgetElem.append(_drawHotelCard());
		widgetElem.append(blockWidgetContainer);

		me.remove = function() {
			widgetElem.remove();
		};
	};

	var update = {
		roommates: function(sharesData) {
			var blockManageWidget = _.find(blocks, function(block) {
				var room = _.find(block.rooms, function(room) {
					return room.blocked_room_id === sharesData.blocked_room_id;
				});
				return room || false;
			});
			var roomManageWidget = _.find(blockManageWidget.rooms, function(room) {
				return room.blocked_room_id === sharesData.blocked_room_id;
			});
			roomManageWidget.updateRoommates(sharesData.sharesArray);
		}
	};

	me.bind('BlockManageWidget.removeBlock', function(event, eventData) {
		_.each(me.blocks, function(block) {
			if(eventData.block_id === block.block_id) {
				_removeBlock(block, eventData.block_id);
			}
		});
	});

	jQuery('body').bind('HotelManageWidget.update', function(event, updateData) {
		update[updateData.method](updateData);
	});

}, {
	WUID: 'DEFAULT',
	widgetName: 'HotelManageWidget',
	hotelData: {},
	blockData: {},
	meetingInfo: {},
	requestsInfo: {},
	modifyRoomData: {},
	searchMode: false,
	cancelInfo: {},
	groupInfo: {},
	countriesAndStates: {},
	labels: {
		hotelCutoffMessage: 'This hotel is cut off and reservations can no longer be edited.'
	}
});
